import { useCallback, useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import { teleVisitAPI } from '../../../apis';

import DiaLog from '../../../components/Dialog';

import { i18n } from '../../../language';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#538fff',
    color: theme.palette.common.white,
    fontSize: 16,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    fontFamily: 'NotoSans-Bold,NotoSans-Medium',
    fontWeight: '500',
    fontSize: '1rem',
    minWidth: '61rem',
  },
  container: {
    maxHeight: 450,
  },
  message: {
    whiteSpace: 'pre-wrap',
    maxWidth: '35rem',
    wordWrap: 'break-word',
  },
  emptyMessage: {
    fontSize: '16px',
    height: '100px',
    width: '61rem',
    marginTop: '50px',
  },
  sender: {
    wordBreak: 'break-all',
    maxWidth: '20rem',
  },
});

const AdHocNotifacationListDialog = ({ open, handleClose, info }) => {
  const classes = useStyles();

  const [list, setList] = useState([]);

  const getNotificationList = useCallback(async () => {
    try {
      const params = {
        bookId: info.bookId,
        wardId: info.wardId,
      };
      const { result } = await teleVisitAPI.getNotificationList(params);
      setList(_.orderBy(result, ['sendTime'], 'desc'));
    } catch (error) {
      console.log(error);
    }
  }, [info.bookId, info.version]);

  useEffect(() => {
    getNotificationList();
  }, [info.bookId, info.version]);

  return (
    <DiaLog open={open} handleClose={handleClose} haveFoot={false} width="100%">
      {list.length !== 0 && (
        <TableContainer className={classes.container}>
          <Table stickyHeader className={classes.table} aria-label={i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST')}>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" style={{ borderRight: 'solid 2px #e4e7eb', minWidth: '11rem' }}>
                  {i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_SENDTIME')}
                </StyledTableCell>
                <StyledTableCell align="center" style={{ borderRight: 'solid 2px #e4e7eb', minWidth: '7rem' }}>
                  {i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_STATUS')}
                </StyledTableCell>
                <StyledTableCell style={{ borderRight: 'solid 2px #e4e7eb', width: '35rem' }}>
                  {i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_MESSAGE')}
                </StyledTableCell>
                <StyledTableCell align="center" style={{ minWidth: '7rem' }}>
                  {i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_SENDER')}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((row) => (
                <StyledTableRow key={row.smsId}>
                  <StyledTableCell align="center" component="th" scope="row">
                    {row.status === 1 && moment(row.sendTime, 'x').format('yyyy-MM-DD HH:mm')}
                    {row.status === 2 && 'NA'}
                    {row.status === 3 && 'NA'}
                  </StyledTableCell>
                  <StyledTableCell align="center" component="th" scope="row">
                    {row.status === 1 && i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_STATUS_COMPLETE')}
                    {row.status === 2 && i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_STATUS_FAILED')}
                    {row.status === 3 && i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_STATUS_INPROGRESS')}
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" className={classes.message}>
                    {row.message}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={classes.sender}>
                    {row.sender === 'SYSTEM' ? i18n.t('TELEVISIT_POPUP_NOTIFICATION_SENDERMSG') : row.sender}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {list.length === 0 && (
        <Box>
          <Box align="center" colSpan={4} className={classes.emptyMessage}>
            {i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST_EMPTY')}
          </Box>
        </Box>
      )}
    </DiaLog>
  );
};

export default AdHocNotifacationListDialog;
